import { render, staticRenderFns } from "./Input.vue?vue&type=template&id=128a35aa&scoped=true&"
import script from "./Input.vue?vue&type=script&lang=ts&"
export * from "./Input.vue?vue&type=script&lang=ts&"
import style0 from "./Input.vue?vue&type=style&index=0&id=128a35aa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "128a35aa",
  null
  
)

export default component.exports